import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton'
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import SelectComp from '../../utils/Select/SelectComp';
import ConfirmAlert from '../../utils/ConfirmAlert/ConfirmAlert';
import Images from './images/Images';
import { imageBaseUrl } from '../../../config/keys';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import { addCategory } from '../../Banner/Banner.api';
const ConfCategory = (props) => {
    const [selectedImage, setSelectedImage] = React.useState();
    const [selectedIcon, setSelectedIcon] = React.useState();
    const [images,setImages] = React.useState([]);
    const [icons,setIcons] = React.useState([]);
    const [formData,setFormData] = React.useState({
        categoryId: "",
        categoryName: "",
        code: uuidv4(),
        status: "Active",
        displayName:'',
        sequenceOrder: 0,
        isEnabled:'No'
    });
    const [err,setErr] = React.useState({
        categoryName: false
    })
    const [loading,setLoading] = React.useState(false)
    const imageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          setSelectedImage(e.target.files[0]);
        }
    };
    // This function will be triggered when the "Remove This Image" button is clicked
    const removeSelectedImage = () => {
        setSelectedImage();
    };
    const iconChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          setSelectedIcon(e.target.files[0]);
        }
    };
    // This function will be triggered when the "Remove This Image" button is clicked
    const removeSelectedIcon = () => {
        setSelectedIcon();
    };
    const onRemoveImage = (index) => {
        // id key is having the index of original image
        console.log("Remove image id", index);
        let prevUploadedImages = [...images];
        prevUploadedImages.splice(index,1);
        setImages([...prevUploadedImages]);
    };
    const onRemoveIcon = (index) => {
        // id key is having the index of original image
        console.log("Remove image id", index);
        let prevUploadedImages = [...icons];
        prevUploadedImages.splice(index,1);
        setIcons([...prevUploadedImages]);
    };    
    React.useEffect(() => {
        if(props.type == "EDIT") {
            setFormData({...formData,...props.category,categoryId: props.category._id})
            let categoryImage = props.category.categoryImage; 
            categoryImage = categoryImage != undefined && categoryImage != null ? categoryImage:[]; 
            setImages(categoryImage);
            let categoryIcon = props.category.categoryIcon; 
            categoryIcon = categoryIcon != undefined && categoryIcon != null ? categoryIcon:[]; 
            setIcons(categoryIcon);
        }
    },[props.category]);
    // IMAGE
    const handleAddImage = (url) => {
        let arr = images;
        arr.push({imgUrl: url}); 
        setImages([...arr]);
    }
    const handleDeleteImage = (index) => {
        let arr = images;
        arr = arr.filter((val,i) => index != i) 
        setImages([...arr]);
    }
    // Icons
    const handleAddIcon = (url) => {
        let arr = icons;
        console.log("Add Icon");
        console.log(url);
        let checkSvg = url.includes(".svg");
        if(checkSvg) {
            arr.push({imgUrl: url}); 
            setIcons([...arr]);
        } else {
            props.setAlert("Upload only SVG images");
        }
    }
    const handleDeleteIcon = (index) => {
        let arr = icons;
        arr = arr.filter((val,i) => index != i) 
        setIcons([...arr]);
    }
    // SUBMIT
    const onSubmit = () => {
        setErr({...err,categoryName: false,code: false});
        if(formData.categoryName == "") {
            setErr({...err,categoryName: "Field cannot be empty"})
        } else if(formData.code == "") {
            setErr({...err,code: "Field cannot be empty"})
        } else {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editCategory" : "/addcategory";
            let requestData = new FormData();
            Object.keys(formData).forEach(fieldName => {
                console.log(fieldName, formData[fieldName]);
                if(fieldName == 'categoryImage' || fieldName =='categoryIcon') {
                    console.log('Not appended:',fieldName+' = '+ formData[fieldName]);
                } else {
                    requestData.append(fieldName, formData[fieldName]);
                }
            });
            if(props.type == 'EDIT') {
                requestData.append("categoryImage", images && images.length > 0 ? JSON.stringify(images):[]);
                requestData.append("categoryIcon", icons && icons.length > 0 ? JSON.stringify(icons):[]);
            }
            if(selectedImage) {
                requestData.append('newImage', selectedImage);    
            }
            if(selectedIcon) {
                requestData.append('newIcon', selectedIcon);
            }
            console.log(...requestData);
            addCategory(props.type,requestData)
            .then(res => {
                console.log('response');
                console.log(res);
                if(res.success) {
                    setFormData({categoryId: "",categoryName: "",code: uuidv4(),status: "",sequenceOrder: 0,displayName:'',
                    isEnabled:'No'})
                    setImages([]);
                    setIcons([]);
                    setSelectedIcon();
                    setSelectedImage();
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    
                } else {
                    setLoading(false);
                    let msg = res.msg;   
                    props.setAlert(msg != '' ? msg :"Something went wrong Try Again");
                }
            }).catch(err => {
                console.log(err)
                props.setAlert("Something went wrong Try Again")
                setLoading(false)
            })
        }
    }
    const oldOnSubmit = () => {
        setErr({...err,categoryName: false,code: false});
        if(formData.categoryName == "") {
            setErr({...err,categoryName: "Field cannot be empty"})
        } else if(formData.code == "") {
            setErr({...err,code: "Field cannot be empty"})
        } else {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editCategory" : "/addcategory";
            
            axios({
                method: "post",
                url: url,
                data: {
                    ...formData,
                    categoryImage: images,
                    categoryIcon: icons,
                }
            })
            .then(res => {
                if(res.data.success) {
                    setFormData({categoryId: "",categoryName: "",code: uuidv4(),status: "",sequenceOrder: 0,displayName:'',
                    isEnabled:'No'})
                    setImages([]);
                    setIcons([]);
                    props.onDone();
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    
                } else {
                    setLoading(false)
                    props.setAlert("Something went wrong Try Again")
                }
            }).catch(err => {
                console.log(err)
                props.setAlert("Something went wrong Try Again")
                setLoading(false)
            })
        }
    }
    let btnText = props.type == "EDIT" ? "Update Category" : "Add Category";
    return (
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>
                    <h2>Details</h2>
                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Category Name"
                                value={formData.categoryName}
                                onBlur={(e) => setFormData({...formData,categoryName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,categoryName: e.target.value})}
                                error={err.categoryName}
                                helperText={err.categoryName}
                            />
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Code"
                                value={formData.categories_barcode}
                                onChange={(e) => setFormData({...formData,code: e.target.value})}
                                error={err.code}
                                helperText={err.code}
                                disabled
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Display Name"
                                value={formData.displayName}
                                onBlur={(e) => setFormData({...formData,displayName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,displayName: e.target.value})}
                                // error={err.displayName}
                                // helperText={err.displayName}
                            />
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Sequence Number"
                                value={formData.sequenceOrder}
                                type="number"
                                onChange={(e) => setFormData({...formData,sequenceOrder: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                            <SelectComp
                                variant="outlined"
                                className={styles.textField}
                                label="Set Ecommerce Enabled"
                                value={formData.isEnabled}
                                onChange={(e) => setFormData({...formData,isEnabled: e.target.value})}
                                options={["Yes","No"]}
                                values={["Yes","No"]}
                            />
                            <SelectComp
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status}
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            />
                        </div>
                    </div>
                    <Divider />
                    <div className={styles.content}>
                        <h2 style={{marginTop:10,marginBottom:10}}>Image</h2>
                        <div style={{marginBottom:10}} className={styles.row}>
                        {props.type == 'EDIT' &&
                            images && images.map((item,index) => (
                                <div id={index}>
                                <img 
                                    style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                                    src={(imageBaseUrl +item.imgUrl)}
                                    alt="new"
                                    />
                                    <div style={{fontWeight:'bold',width:'270px',backgroundColor:'gray',paddingLeft:5}}>
                                        <h6 style={{margin:'2%'}}>
                                        <ConfirmAlert msg='Are you sure you want delete image ?' onClickEvent={() => onRemoveImage(index)}> 
                                            <IconButton>
                                            <DeleteRoundedIcon />
                                            </IconButton>
                                        </ConfirmAlert>
                                        Delete
                                        </h6>  
                                    </div>
                                </div>
                            ))}
                            <div>
                                <input
                                accept="image/*"
                                type="file"
                                onChange={imageChange}
                                />

                                {selectedImage && (
                                <div className={styles.preview}>
                                    <img
                                    src={URL.createObjectURL(selectedImage)}
                                    style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                                    alt="Thumb"
                                    />
                                    <button onClick={removeSelectedImage}>
                                    Deselect
                                    </button>
                                </div>
                                )}
                            </div>
                        </div>
                        
                        {/* <Images 
                            images={images}
                            onAddImage={(url) => handleAddImage(url)}
                            onDeleteImage={(index) => handleDeleteImage(index)}
                        /> */}
                        
                    </div>
                    <Divider />
                    <div className={styles.content}>
                        <h2 style={{marginTop:10,marginBottom:10}}>Icon : only SVG images</h2>
                        <div style={{marginBottom:10}} className={styles.row}>
                        {props.type == 'EDIT' &&
                            icons && icons.map((item,index) => (
                                <div id={index}>
                                <img 
                                    style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                                    src={(imageBaseUrl +item.imgUrl)}
                                    alt="new"
                                    />
                                    <div style={{fontWeight:'bold',width:'270px',backgroundColor:'gray',paddingLeft:5}}>
                                        <h6 style={{margin:'2%'}}>
                                        <ConfirmAlert msg='Are you sure you want delete image ?' onClickEvent={() => onRemoveIcon(index)}> 
                                            <IconButton>
                                            <DeleteRoundedIcon />
                                            </IconButton>
                                        </ConfirmAlert>
                                        Delete
                                        </h6>  
                                    </div>
                                </div>
                            ))}
                            <div>
                                <input
                                accept=".svg"
                                type="file"
                                onChange={iconChange}
                                />

                                {selectedIcon && (
                                <div className={styles.preview}>
                                    <img
                                    src={URL.createObjectURL(selectedIcon)}
                                    style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                                    alt="Thumb"
                                    />
                                    <button onClick={removeSelectedIcon}>
                                        Deselect
                                    </button>
                                </div>
                                )}
                            </div>
                        </div>
                        
                        {/* <Images 
                            images={icons}
                            onAddImage={(url) => handleAddIcon(url)}
                            onDeleteImage={(index) => handleDeleteIcon(index)}
                        /> */}
                        <Divider />
                    </div>
                    
                    <div className={styles.footer}>
                        {loading
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>
    )
}
const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfCategory);
